import classNames from 'classnames';
import HeaderText from 'containers/settings/components/HeaderText/HeaderText';
import { t } from 'i18next';
import { AnyObject } from 'types/util/Object';

export interface RequireEquipmentFormHeaderTextProps {
  className?: string | AnyObject;
}

export function RequireEquipmentFormHeaderText({ className }: RequireEquipmentFormHeaderTextProps) {
  return (
    <HeaderText
      title={t('Require Equipment (Clock Only)')}
      className={classNames('require-equipment-form-header-text', className)}
    >
      {t(
        'When clocking their own time, require employees to either select equipment or explicitly opt out of the selection. Employees can still be assigned non-equipment time through Supervisor actions.'
      )}
    </HeaderText>
  );
}
